module.exports = __webpack_public_path__ + "static/media/exitalt.bc8aed2c.svg";